import { createBrowserLogger } from '../../../utils/createBrowserLogger.ts';

/**
 * Per abilitare i log di debug, aggiungere la chiave `FWEngineLogger_expression`
 * es. `window.FWEngineLogger_expression = true`
 */
export const expressionLogger = createBrowserLogger({
  isActive: process.env.NODE_ENV === 'development',
  debugKey: 'expression',
});
